export default [
  {
    id: 'download',
    title: 'Download',
    icon: 'mdi-download',
    action: 'download'
  },
  {
    id: 'delete',
    title: 'Delete',
    icon: 'mdi-delete',
    action: 'delete'
  }
];
